// extracted by mini-css-extract-plugin
export default {"creditCardTypeIcon":"CreditCardType_creditCardTypeIcon__t+v4L"};